<template>
    <customModal :containerxl="true" @closeModal="closePopup">
        <template #title> Field Rule </template>
        <template #body>
             <div class="ibox-title bg-light">
                <h5 class="mb-0">{{ data.editCheckId }} : {{ data.formName }}</h5>
            </div>
            <div class="ibox-content mb-2">
                <div class="form-row">
                    <div class="col-md-6">
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Form Id:</strong></label>
                            <p class="px-2 mb-0">{{ data.formName }}</p>
                        </div>
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Field Name:</strong></label>
                            <p class="px-2 mb-0">{{ data.fieldName }}</p>
                        </div>
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>language Code:</strong></label>
                            <p class="px-2 mb-0">{{ data.languageCode }}</p>
                        </div>
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Version:</strong></label>
                            <p class="px-2 mb-0">{{ data.version }}</p>
                        </div>
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Category:</strong></label>
                            <p class="px-2 mb-0">{{ data.category }}</p>
                        </div>
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Severity:</strong></label>
                            <p class="px-2 mb-0">{{ data.severity }}</p> 
                        </div>
                         <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Trigger Type:</strong></label>
                            <p class="px-2 mb-0">{{ data.triggerType }}</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Condition:</strong></label>
                            <p class="px-2 mb-0">{{ data.condition }}</p>
                        </div>
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Message Type:</strong></label>
                            <p class="px-2 mb-0">{{ data.messageType }}</p>
                        </div>
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Approval Status:</strong></label>
                            <p class="px-2 mb-0">{{ data.approvalStatus }}</p>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group mb-1 d-flex align-items-center">
                            <label class="mb-0 "><strong>Message:</strong></label>
                            <p class="px-2 mb-0">{{ data.message }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </customModal>
</template>
<script src="./FieldRulePopup.js"></script>